<script>
import Render from "../Render.svelte"
export let elements = undefined
</script>

{#each elements as element}
  <Render element="{element}" />
{/each}
